export default __webpack_public_path__ + "static/media/White_logo.af62d174.png";